/*
  cart-variant-pick.js — the variant sheet for Complete Your Routine.

  WHY THIS EXISTS RATHER THAN THE SHARED QUICK-ADD MODAL. That modal fetches the
  whole product page and shows gallery, description and full pricing: correct on
  a collection card, far too much inside a cart. This picker shows the two things
  that are actually being chosen between — the variant and its price — and
  nothing else.

  It is deliberately the ONLY place in the theme with its own picker, and it is
  scoped to the cart drawer. Everywhere else still opens the shared modal.

  NOTHING HERE ADDS TO THE CART. The sheet lives inside a real <product-form>;
  choosing a variant only writes that variant's id into the form's own
  `name="id"` field, and the Add to Cart button is that form's submit. The add
  goes through product-form.js exactly like every other add on the site, which is
  also what re-renders the drawer afterwards and makes the sheet disappear.

  Event delegation on document, because cart-drawer-items is replaced wholesale
  on every cart change (cart.js:96) — handlers bound to the cards themselves
  would be thrown away with them.
*/
(function () {
  'use strict';

  var OPEN = 'cart-vp--open';

  function sheetOf(el) {
    var form = el.closest('.cart-routine__form');
    return form ? form.querySelector('.cart-vp') : null;
  }

  function closeAll(except) {
    var open = document.querySelectorAll('.cart-vp.' + OPEN);
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove(OPEN);
      open[i].setAttribute('hidden', '');
    }
  }

  function open(sheet, opener) {
    closeAll(sheet);
    sheet.removeAttribute('hidden');
    /* The class lands on the next frame so the panel has a frame at its start
       position to transition FROM; set together with [hidden] being removed it
       would jump straight to the end state. */
    requestAnimationFrame(function () {
      sheet.classList.add(OPEN);
      var first = sheet.querySelector('.cart-vp__opt[aria-pressed="true"]') || sheet.querySelector('.cart-vp__opt:not([disabled])');
      if (first) first.focus();
    });
    if (opener) sheet.openedBy = opener;
  }

  function close(sheet) {
    sheet.classList.remove(OPEN);
    sheet.setAttribute('hidden', '');
    if (sheet.openedBy) {
      sheet.openedBy.focus();
      sheet.openedBy = null;
    }
  }

  function choose(button) {
    var sheet = button.closest('.cart-vp');
    if (!sheet) return;

    var opts = sheet.querySelectorAll('.cart-vp__opt');
    for (var i = 0; i < opts.length; i++) {
      opts[i].setAttribute('aria-pressed', opts[i] === button ? 'true' : 'false');
    }

    /* The form's own variant field — the same input Dawn posts. */
    var form = sheet.closest('.cart-routine__form');
    var input = form && form.querySelector('.product-variant-id');
    if (input) input.value = button.getAttribute('data-vp-variant');

    var submit = sheet.querySelector('.cart-vp__submit');
    if (submit) submit.disabled = button.hasAttribute('disabled');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest ? e.target.closest('[data-vp-open]') : null;
    if (openBtn) {
      var sheet = sheetOf(openBtn);
      if (sheet) {
        e.preventDefault();
        if (sheet.classList.contains(OPEN)) close(sheet);
        else open(sheet, openBtn);
      }
      return;
    }

    var closeBtn = e.target.closest ? e.target.closest('[data-vp-close]') : null;
    if (closeBtn) {
      var s = closeBtn.closest('.cart-vp');
      if (s) {
        e.preventDefault();
        close(s);
      }
      return;
    }

    var opt = e.target.closest ? e.target.closest('[data-vp-variant]') : null;
    if (opt) {
      e.preventDefault();
      choose(opt);
      return;
    }

    /* A click anywhere that is not inside an open sheet closes it. */
    if (!e.target.closest || !e.target.closest('.cart-vp')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* The drawer closing leaves no click behind, so the sheet would still be open
     the next time it is opened. */
  document.addEventListener('cart:refresh', function () {
    closeAll(null);
  });
})();
